/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-21 19:40:42
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-10 10:55:13
 */
import React, { PureComponent } from "react";
import Field from "./Field";

import { Col, DragIcon, dummyFn, ConfirmFn } from "../utils";

export default class FieldWrapper extends PureComponent {
	render() {
		const { config, selectedField, setField, parentField, classname, readonly, id, groupId, handleDraggerMouseDown } = this.props;

		const renderDrag = () => {
			return (
				<span key="rule-drag-icon" className={"qb-drag-handler rule--drag-handler"} onMouseDown={handleDraggerMouseDown}>
					<DragIcon />
				</span>
			);
		};
		return (
			<Col className={classname}>
				{config.settings.showLabels && <label className="rule--label">{config.settings.fieldLabel}</label>}
				<div className="rule--drag-button">{renderDrag()}</div>
				<Field
					config={config}
					selectedField={selectedField}
					parentField={parentField}
					setField={setField}
					customProps={config.settings.customFieldSelectProps}
					readonly={readonly}
					id={id}
					groupId={groupId}
				/>
			</Col>
		);
	}
}
